import React from 'react'
import {useSelector} from "react-redux"
import {Typography} from "@material-ui/core"
import {Link} from "react-router-dom"
import CheckoutSteps from "./CheckoutSteps"
import "./confirmOrder.css"
import Metadata from '../layout/Metadata';



const ConfirmOrder = ({history}) => {
  const {shippingInfo, cartItems} = useSelector((state) => state.cart)

  const {user} = useSelector((state) => state.user)

  const subtotal = cartItems.reduce((ac,el) => 
    ac + el.quantity * el.price 
  ,0)

  const shippingCharges = subtotal >= 1000 ? 0 : 150

  const tax = subtotal * 0.18

  const totalPrice = subtotal + tax + shippingCharges

  const address = `${shippingInfo.address}, ${shippingInfo.city}, ${shippingInfo.state}, ${shippingInfo.pinCode}, ${shippingInfo.country}`  

  const proceedToPayment = () => {
    const data = {
      subtotal,
      shippingCharges,
      tax,
      totalPrice
    }
    sessionStorage.setItem("orderInfo", JSON.stringify(data))

    history.push("/process/payment")
  }






  return (
    <>
    <Metadata title = "Confirm Order" />

    <CheckoutSteps activeStep = {1} />
    <div className="confirmOrderPage">
      <div>
        <div className="confirmShippingArea">
          <Typography>Shipping Info</Typography>
          <div className="confirmShippingAreaBox">
              <div>
                <p>Name:</p>
                <span>{user.name}</span>
              </div>
              <div>
                <p>Phone:</p>
                <span>{shippingInfo.phoneNo}</span>
              </div>
              <div>
                <p>Address:</p>
                <span>{address}</span>
              </div>
            </div>
        </div>
        <div className="confirmCartItems">
          <Typography>Your Cart Items:</Typography>
          <div className="confirmCartItemsContainer">
              {cartItems &&
                cartItems.map((item) => (
                  <div key={item.product}>
                    <img src={item.image} alt="Product" />
                    <Link to={`/product/${item.product}`}>
                      {item.name}
                    </Link>{" "}
                    <span>
                      {item.quantity} X ₹{item.price} ={" "}
                      <b>₹{item.price * item.quantity}</b>
                    </span>
                  </div>
                ))}
            </div>
        </div>
      </div>
      <div>
          <div className="orderSummary">
            <Typography>Order Summery</Typography>
            <div>
              <div>
                <p>Subtotal:</p>
                <span>₹{subtotal}</span>
              </div>
              <div>
                <p>Shipping Charges:</p>
                <span>₹{shippingCharges}</span>
              </div>
              <div>
                <p>GST:</p>
                <span>₹{tax}</span>
              </div>
            </div>

            <div className="orderSummaryTotal">
              <p>
                <b>Total:</b>
              </p>
              <span>₹{totalPrice}</span>
            </div>

            <button onClick={proceedToPayment}>Proceed To Payment</button>
          </div>
        </div>


    </div>
    </>
  )
}

export default ConfirmOrder